import classes from "./Account.module.css";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/authSlice";
import { useNavigate, Navigate, Outlet } from "react-router-dom";

const Account = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    navigate("personalInfo");
  }, []);

  const logoutHandler = () => {
    dispatch(authActions.logout());
    navigate("/", { replace: true });
  };

  const selectChangeHandler = (e) => {
    switch (e.target.value) {
      case "liked-items":
        navigate("likedItems");
        break;
      case "other-questions":
        navigate("otherQuestions");
        break;
      case "personal-info":
        navigate("personalInfo");
        break;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: "0.1" } }}
      className={classes.account}
    >
      <div>
        <p className={classes.text}>Hello, USER NAME</p>
        <span className={classes.logout} onClick={logoutHandler}>
          登出
        </span>
      </div>
      <select
        name="account"
        id="account"
        onChange={selectChangeHandler}
        defaultValue="personal-info"
      >
        <option value="personal-info">個人資訊</option>
        <option value="liked-items">喜愛的商品</option>
        <option value="other-questions">其他問題</option>
      </select>

      <Outlet />
    </motion.div>
  );
};

export default Account;
